module.exports = __webpack_public_path__ + "img/selectButton.53521239.svg";